import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { TPageProps } from 'models/common.model'
import { useDelayedContinue } from 'hooks/useDelayedContinue'
import { useNextStep } from 'hooks/useNextStep'
import { Option, OptionType } from 'components/Option'
import { Container } from 'components/Container'
import { AnswerButtonLight } from 'components/AnswerButtonLight'
import { StyledFeelStressed as S } from './FeelStressed.styles'
import { OPTION_VALUES, QUESTION } from './constants'

export const FeelStressed: React.FC<TPageProps> = ({
  pageId,
  nextPagePath,
}) => {
  const { t } = useTranslation()
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    pageId,
    question: QUESTION,
    nextPagePath,
  })

  const optionProps = useMemo(
    () => ({
      name: pageId,
      type: OptionType.RADIO,
      onChange: (value: string) => {
        handleChange(value, handleContinue)
        setIsAnswersDisabled(true)
      },
    }),
    [handleChange, setIsAnswersDisabled, handleContinue, pageId],
  )

  return (
    <Container>
      <S.Title>{t('onboarding.feelStressed.title')}</S.Title>

      <Option
        {...optionProps}
        disabled={isAnswersDisabled}
        value={OPTION_VALUES.NEVER}
      >
        <AnswerButtonLight>
          {t('onboarding.feelStressed.options.never')}
        </AnswerButtonLight>
      </Option>

      <Option
        {...optionProps}
        disabled={isAnswersDisabled}
        value={OPTION_VALUES.ONE_TWO_TIMES}
      >
        <AnswerButtonLight>
          {t('onboarding.feelStressed.options.oneTwoTimes')}
        </AnswerButtonLight>
      </Option>

      <Option
        {...optionProps}
        disabled={isAnswersDisabled}
        value={OPTION_VALUES.THREE_FOR_TIMES}
      >
        <AnswerButtonLight>
          {t('onboarding.feelStressed.options.threeFourTimes')}
        </AnswerButtonLight>
      </Option>

      <Option
        {...optionProps}
        disabled={isAnswersDisabled}
        value={OPTION_VALUES.ALMOST_EVERYDAY}
      >
        <AnswerButtonLight>
          {t('onboarding.feelStressed.options.almostEveryDay')}
        </AnswerButtonLight>
      </Option>
    </Container>
  )
}
